import Quote from './Quote';

function QuoteList({ quotes, setQuotes }) {
	if (quotes.length === 0) {
		return (
			<p className='message'>
				There are no quotes in this category yet! Be the first to add your
				favourite quote! 😊
			</p>
		);
	}
	return (
		<section>
			<ul className='quotes'>
				{quotes.map((quote) => (
					<Quote
						key={quote.id}
						quote={quote}
						setQuotes={setQuotes}
					/>
				))}
			</ul>
		</section>
	);
}
export default QuoteList;
